import { z } from 'zod';
/**
 * Achievement badges. [Teen Phase 6 — Dashboard & Tracking]
 *
 * Earned from work that actually happened, evaluated on every read rather than
 * stored. A badge is a claim about someone, so it has to stay true: a stored
 * grant would keep saying "Five jobs done" after a job was withdrawn, and a
 * badge that can lie is worse than no badge.
 *
 * Admin-granted trust badges are the exception — those are a judgement rather
 * than a measurement, so they live in `user_badges`.
 */
export const badgeCategorySchema = z.enum(['TRUST', 'ACHIEVEMENT']);
export const badgeSchema = z.object({
    /** Stable key, safe to use for an icon lookup. */
    slug: z.string(),
    name: z.string(),
    /** What someone has to do to get it, in their own terms. */
    description: z.string(),
    category: badgeCategorySchema,
    earned: z.boolean(),
    /** When it was earned. Null while it is still locked. */
    earnedAt: z.string().nullable(),
    /**
     * How close they are, 0 to 1. Null for a badge with nothing to count —
     * a trust badge is granted, not progressed towards.
     */
    progress: z.number().min(0).max(1).nullable(),
    /** "3 of 5 jobs", so the number is never left to be inferred from a bar. */
    progressLabel: z.string().nullable(),
});
export const badgesResponseSchema = z.object({
    badges: z.array(badgeSchema),
    earnedCount: z.number().int().min(0),
});
//# sourceMappingURL=badges.js.map